import { adminStore } from '#lib/stores/admin.js';
import { optimisticSet } from '#lib/stores/optimistic.js';
import {
	apiAppSettingsFeatureflippingFlip,
	apiAppSettingsFeatureflippingRead,
	FeatureFlag
} from '#lib/types/generated/index.js';
import { derived, get, writable } from 'svelte/store';

export { FeatureFlag as features, FeatureFlag };

export const featureFlipStore = writable<{ features: FeatureFlag[] }>({ features: [] });

export function reloadFeatureFlip(): Promise<void> {
	return apiAppSettingsFeatureflippingRead().then((response) => {
		featureFlipStore.set({ features: response.features });
	});
}

export function flipFeature(name: FeatureFlag, forceSave = false) {
	const current = get(featureFlipStore);
	const value = !current.features.includes(name);
	const updated = {
		features: value
			? [...current.features, name]
			: current.features.filter((feature) => feature !== name)
	};

	const shouldSave =
		!get(adminStore) ||
		(current.features.includes(FeatureFlag.Ghost) && name !== FeatureFlag.Ghost) ||
		forceSave;

	if (shouldSave) {
		return optimisticSet(featureFlipStore, updated, () =>
			apiAppSettingsFeatureflippingFlip({ features: [{ name, value }] })
		);
	}

	featureFlipStore.set(updated);
	return Promise.resolve(updated);
}

export const isFeatureEnabled = derived(
	[featureFlipStore],
	([$featureFlipStore]) =>
		(feature: FeatureFlag) => {
			return $featureFlipStore.features.includes(feature);
		}
);
